import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import React, { useMemo } from "react";
import Image from "next/image";
import { Link } from '@/i18n/navigation';

const DEFAULT_HOTELS = [{
  id: "otel-1",
  src: "/images/dummy/hotel-detail-1.jpg",
  label: 'Radisson Beijing Otel'
}, {
  id: "otel-2",
  src: "/images/dummy/hotel-detail-2.jpg",
  label: 'Hampton by Hilton Ankara Esenboğa Airport'
}, {
  id: "otel-3",
  src: "/images/dummy/hotel-detail-3.jpg",
  label: 'Radisson Beijing Otel'
}, {
  id: "otel-4",
  src: "/images/dummy/hotel-detail-4.jpg",
  label: 'Oz Hotels İncekum Beach Resort'
}];

const NearbyHotels = ({ hotelData }) => {
  const t = useTranslationDetector('hotel');

  // API'den gelen NearestHotels'ı kullan
  const hotels = useMemo(() => {
    const nearestHotels = hotelData?.NearestHotels || [];

    if (nearestHotels.length > 0) {
      return nearestHotels.map((hotel, index) => ({
        id: hotel.Slug ? `${hotel.Slug}-${index}` : `hotel-${index}`,
        src: hotel.Image || '/images/dummy/hotel-detail-1.jpg',
        label: hotel.Name || '',
        slug: hotel.Slug,
      }));
    }

    return DEFAULT_HOTELS;
  }, [hotelData]);

  if (hotels.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 md:gap-6 md:py-12 py-6">
      <div className="text-xl sm:text-[23px] md:text-[29px]! font-semibold">
        {t('nearbyHotels')}
      </div>

      <div className="flex md:grid grid-cols-4 gap-4 md:gap-6 overflow-x-auto scrollbar-hide">
        {hotels.map((hotel, index) => {
          const content = (
            <>
              <div className="relative w-[294px] h-[165px] sm:w-[162px] sm:h-[91px] xl:w-[294px] xl:h-[165px] aspect-[16/9] overflow-hidden rounded-lg shrink-0">
                <Image
                  src={hotel.src}
                  alt={hotel.label}
                  fill
                  sizes="294px"
                  className="object-cover"
                />
              </div>

              <div className="font-semibold text-lg">
                {hotel.label}
              </div>
            </>
          );

          return hotel.slug ? (
            <Link
              key={hotel.id || index}
              href={`${hotel.slug}`}
              className="flex flex-col gap-4 md:col-span-1"
            >
              {content}
            </Link>
          ) : (
            <div key={hotel.id || index} className="flex flex-col gap-4 md:col-span-1 max-md:min-w-[80vw]">
              {content}
            </div>
          );
        })}
      </div>
    </div>
  )
};

export default NearbyHotels;